import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Info } from "lucide-react";
import { loadState, saveState } from "@/lib/storage";
import { toast } from "sonner";

export default function SettingsPage() {
  const [url, setUrl] = useState(() => loadState().dataSourceUrl || "");

  const handleSave = () => {
    const next = loadState();
    next.dataSourceUrl = url.trim();
    saveState(next);
    toast.success(
      url.trim()
        ? "URL saved. Custom data sources will be supported soon."
        : "URL cleared.",
    );
  };

  return (
    <section data-testid="settings-page">
      <div className="text-xs uppercase tracking-[0.2em] font-medium text-[#52525B]">
        Configuration
      </div>
      <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-[#0A0A0A] leading-none mt-1">
        Settings
      </h1>

      <div className="mt-8 border border-[#E4E4E7] rounded-md bg-white p-5">
        <Label
          htmlFor="sheet-url"
          className="text-xs uppercase tracking-[0.2em] font-medium text-[#52525B]"
        >
          Google Sheets URL
        </Label>
        <Input
          id="sheet-url"
          type="url"
          placeholder="https://docs.google.com/spreadsheets/…"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className="mt-2 rounded-md border-[#E4E4E7] focus-visible:ring-[#0A0A0A]"
          data-testid="sheet-url-input"
        />
        <p className="mt-3 text-xs text-[#A1A1AA] flex items-start gap-2">
          <Info className="h-3.5 w-3.5 mt-0.5 shrink-0" />
          Paste a public Google Sheets link with two columns: <strong>Country</strong> and{" "}
          <strong>Capital</strong>. (Custom-source quizzes coming soon — the
          built-in 195-country database is currently in use.)
        </p>
        <Button
          onClick={handleSave}
          className="mt-5 w-full bg-[#0A0A0A] hover:bg-[#27272A] text-white rounded-md"
          data-testid="save-settings-button"
        >
          Save
        </Button>
      </div>

      <div className="mt-6 border border-[#E4E4E7] rounded-md bg-white p-5">
        <div className="text-xs uppercase tracking-[0.2em] font-medium text-[#52525B] mb-2">
          Current data source
        </div>
        <div className="text-sm text-[#0A0A0A]" data-testid="current-data-source">
          Built-in database · 195 countries
        </div>
      </div>
    </section>
  );
}
